export const contact = {
  title: 'Contact Us',
  subtitle: 'Get in touch with our team',
  email: {
    abuse: {
      title: 'Abuse',
      address: 'abuse@synthohosting.net'
    },
    tech: {
      title: 'Technical Support',
      address: 'tech@synthohosting.net'
    },
    info: {
      title: 'General Info',
      address: 'info@synthohosting.net'
    },
    admin: {
      title: 'Administrative',
      address: 'amministrativo@synthohosting.net'
    }
  },
  phone: {
    title: 'Phone',
    number: '+39 0984 180 0706'
  },
  address: {
    title: 'Address',
    line1: 'Via Isonzo 102',
    line2: '73055 Racale (LE)',
    country: 'Italy'
  },
  company: {
    title: 'Company Information',
    name: 'MULTI SERVICE S.R.L.S.',
    vat: 'P.IVA / VAT.ID: IT 05316380756',
    rea: 'REA: LE - 358063'
  }
};